{
    "Valider la commande gratuite": {
        "de": "Kostenlose Bestellung bestätigen",
        "en": "Confirm free order"
    },
    "Le montant du panier a changé. Relisez le récapitulatif avant de confirmer.": {
        "de": "Der Warenkorbbetrag hat sich geändert. Prüfen Sie die Zusammenfassung vor der Bestätigung.",
        "en": "The basket amount has changed. Review the summary before confirming."
    },
    "Code promotionnel": {
        "de": "Aktionscode",
        "en": "Promotion code"
    },
    "Votre code promotionnel": {
        "de": "Ihr Aktionscode",
        "en": "Your promotion code"
    },
    "Jusqu’à trois codes, si leurs conditions autorisent le cumul. Les limites par compte exigent une adresse vérifiée.": {
        "de": "Bis zu drei Codes, sofern kombinierbar. Kontolimits erfordern eine bestätigte Adresse.",
        "en": "Up to three codes where their terms allow combining. Account limits require a verified address."
    },
    "Appliquer le code": {
        "de": "Code anwenden",
        "en": "Apply code"
    },
    "Retirer ce code": {
        "de": "Diesen Code entfernen",
        "en": "Remove this code"
    },
    "Prix avant promotions": {
        "de": "Preis vor Rabatten",
        "en": "Price before promotions"
    },
    "Économie": {
        "de": "Ersparnis",
        "en": "Saving"
    },
    "Total après promotions": {
        "de": "Gesamtbetrag nach Rabatten",
        "en": "Total after promotions"
    },
    "Ce code a expiré. Retirez-le pour poursuivre au prix sans cette remise.": {
        "de": "Dieser Code ist abgelaufen. Entfernen Sie ihn, um ohne diesen Rabatt fortzufahren.",
        "en": "This code has expired. Remove it to continue at the price without this discount."
    },
    "Ce code promotionnel est indisponible.": {
        "de": "Dieser Aktionscode ist nicht verfügbar.",
        "en": "This promotion code is unavailable."
    },
    "Cette clé désigne une autre remise.": {
        "de": "Diese Referenz gehört zu einem anderen Rabatt.",
        "en": "This reference belongs to a different discount."
    },
    "Le quota de ce code promotionnel est atteint.": {
        "de": "Das Kontingent dieses Aktionscodes ist ausgeschöpft.",
        "en": "This promotion code has reached its usage limit."
    },
    "Ce code exige une connexion avec votre adresse vérifiée et vos coordonnées dans le panier.": {
        "de": "Melden Sie sich mit Ihrer bestätigten Adresse an und geben Sie Ihre Kontaktdaten im Warenkorb ein.",
        "en": "This code requires you to sign in with your verified address and enter your details in the basket."
    },
    "Ce compte a atteint la limite d’utilisation de ce code.": {
        "de": "Dieses Konto hat das Nutzungslimit für diesen Code erreicht.",
        "en": "This account has reached the usage limit for this code."
    },
    "Ce code est déjà présent dans le panier.": {
        "de": "Dieser Code befindet sich bereits im Warenkorb.",
        "en": "This code is already in the basket."
    },
    "Un panier accepte au plus trois codes promotionnels.": {
        "de": "Ein Warenkorb akzeptiert höchstens drei Aktionscodes.",
        "en": "A basket accepts at most three promotion codes."
    },
    "Ces codes promotionnels ne sont pas cumulables.": {
        "de": "Diese Aktionscodes können nicht kombiniert werden.",
        "en": "These promotion codes cannot be combined."
    },
    "Un code a expiré. Retirez-le explicitement avant de poursuivre.": {
        "de": "Ein Code ist abgelaufen. Entfernen Sie ihn ausdrücklich, bevor Sie fortfahren.",
        "en": "A code has expired. Remove it explicitly before continuing."
    },
    "Ce code ne s’applique à aucune ligne payante de ce panier.": {
        "de": "Dieser Code gilt für keinen kostenpflichtigen Artikel in diesem Warenkorb.",
        "en": "This code does not apply to any payable item in this basket."
    },
    "L’acheteur a changé. Retirez puis appliquez de nouveau le code promotionnel.": {
        "de": "Der Käufer hat sich geändert. Entfernen Sie den Aktionscode und wenden Sie ihn erneut an.",
        "en": "The buyer has changed. Remove and apply the promotion code again."
    },
    "Ajoutez des places avant d’utiliser un code promotionnel.": {
        "de": "Legen Sie Plätze in den Warenkorb, bevor Sie einen Aktionscode verwenden.",
        "en": "Add tickets before using a promotion code."
    },
    "Cette commande gratuite est déjà confirmée.": {
        "de": "Diese kostenlose Bestellung ist bereits bestätigt.",
        "en": "This free order is already confirmed."
    },
    "La composition de cette série a changé. Reprenez votre choix avant de commander.": {
        "de": "Die Zusammensetzung dieser Serie hat sich geändert. Wählen Sie vor der Bestellung erneut.",
        "en": "This series has changed. Review your selection before ordering."
    },
    "Le panier ne correspond pas à cet abonnement.": {
        "de": "Der Warenkorb passt nicht zu diesem Abonnement.",
        "en": "The basket does not match this subscription."
    },
    "Le placement ne correspond plus au devis de la commande.": {
        "de": "Die Platzwahl entspricht nicht mehr dem Angebot der Bestellung.",
        "en": "The seating no longer matches the order quote."
    },
    "Le prix de cette commande doit être vérifié par la billetterie.": {
        "de": "Der Preis dieser Bestellung muss vom Ticketbüro geprüft werden.",
        "en": "The box office must check the price of this order."
    },
    "Le placement de la série comporte un doublon.": {
        "de": "Die Platzwahl der Serie enthält einen doppelten Eintrag.",
        "en": "The series seating contains a duplicate."
    },
    "Commande gratuite": {
        "de": "Kostenlose Bestellung",
        "en": "Free order"
    },
    "Cette commande est gratuite. Vos billets sont disponibles, sans règlement à effectuer.": {
        "de": "Diese Bestellung ist kostenlos. Ihre Tickets sind verfügbar, ohne dass eine Zahlung erforderlich ist.",
        "en": "This order is free. Your tickets are available and no payment is due."
    }
}
